<template>
  <div>
    <!-- <van-nav-bar title="曙光厨房监管中心" /> -->
     <div class="title-image">
        <div class="title-bg-color">
          <div class="title-line"></div>
            <div class="title-text">你好，欢迎登录</div>
            <div class="title-text">曙光厨房监管中心</div>
        </div>
     </div>
     <div class="form-title">用户名登录</div>
     <div class="form-color-line"></div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="user.username"
        required
        name="username"
        label=""
        placeholder="请输入用户名"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="user.password"
        required
        type="password"
        name="code"
        label=""
        placeholder="请输入密码"
        :rules="[{ required: true, message: '' }]"
      />
      <div style="margin: 60px 16px 16px 16px">
        <van-button
          round
          block
          type="primary"
          class="submit-button"
          native-type="submit"
          :loading="isLoading"
          loading-text="正在登录..."
          :disabled="isLoading"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { loginAPI } from '@/api'
import { setToken, delToken } from '@/utils/token'
import { Notify } from 'vant'
export default {
  data() {
    return {
      user: {
        username: '', // 手机号
        password: '' // 密码
      },
      isLoading: false
    }
  },
  async created() {},
  methods: {
    // 提交方法，需要form整体通过验证才会触发
    async onSubmit(values) {
      // 可以直接用values(收集参数名和值)
      console.log('submit', values)
      console.log(this.user)
      this.isLoading = true
      // 清空token
      delToken()
      try {
        const res = await loginAPI(this.user)
        console.log(res)
        if (res.data.state !== 200) {
          Notify({ type: 'danger', message: res.data.message })
          this.isLoading = false
          return
        } else {
          Notify({ type: 'success', message: '登录成功！' })
          // console.log(res.data.token)
          setToken(res.data.data.tokenInfo)
          localStorage.setItem('loginId', res.data.data.id)
          localStorage.setItem('roleId', res.data.data.roleId)
          localStorage.setItem('loginName', res.data.data.name)
          localStorage.setItem('roleCode', res.data.data.roleCode)
          localStorage.setItem('nickName', res.data.data.nickName)
          this.$router.replace({
            path: '/layout/home'
          })
        }
      } catch (error) {
        // Promise内ajax抛出错误，直接进入这里
        Notify({ type: 'danger', message: '账号或密码错误！' })
        this.isLoading = false
      }
      // 网络请求完成
      this.isLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
.submit-button{
  background: #3555EE;
  border-radius: 4px 4px 4px 4px;
}
.title-image{
  height: 274px;
  background-image: url("@/assets/images/login/bg.png");
  background-size: 100% 100%;
}
.title-bg-color{
  width: 100%;
  height: 100%;
  background: linear-gradient(231deg, #FFE0D8 0%, rgba(255, 187, 0, 0) 56%);
  border-radius: 0px 0px 0px 0px;
}
.title-line{
  height: 136px;
}
.title-text{
  height: 42px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 30px;
  color: #FFFFFF;
  margin-left: 20px;
  line-height: 35px;
  text-shadow: 0px 1px 1px #4B7AC7;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.form-title{
  width: 150px;
  height: 28px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 20px;
  color: #474747;
  line-height: 23px;
  margin: 15px 15px 4px 15px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.form-color-line{
  width: 30px;
  height: 4px;
  margin-left: 52px;
  background: #3555EE;
  margin-bottom: 10px;
  border-radius: 1px 1px 1px 1px;
}
/deep/  .van-cell{
  height: 55px;
  line-height: 35px;
}
</style>
